module.exports = __webpack_public_path__ + "static/media/pie.ecf099d2.svg";